import './_listrak-back-in-stock.scss';

(function(d){if(typeof _ltk=="undefined"){if(document.addEventListener)document.addEventListener("ltkAsyncListener",function(){_ltk_util.ready(d)});else{e=document.documentElement;e.ltkAsyncProperty=0;e.attachEvent("onpropertychange",function(e){if(e.propertyName=="ltkAsyncProperty"){_ltk_util.ready(d)}})}}else{_ltk_util.ready(d)}})(function(){
    /********** Begin Custom Code **********/

    const forms = document.querySelectorAll('.listrak-back-in-stock__form');
    if (forms.length === 0) return; // Exit if no forms are found

    const notifyButtons = document.querySelectorAll('.listrak-back-in-stock__notify');
    notifyButtons.forEach(button => button.style.display = 'block'); // Show notify buttons

    forms.forEach(function (form) {
        form.addEventListener('submit', function (event) {
            event.preventDefault(); // Prevent the form's default submission behavior

            const formData = new FormData(form); // Collect form data from the current form

            // Retrieve values using their 'name' attributes within the current form
            const variantSku  = formData.get('variant_sku');
            const email       = formData.get('email_address');
            const phoneNumber = formData.get('phone_number');

            submitListrakBackInStock(variantSku, email, phoneNumber, form);
        });
    });

    function submitListrakBackInStock(sku, email, phone, form) {
        _ltk.Alerts.AddAlertWithIdentifiers({
            AlertCode: 'BIS',
            Sku: sku,
            Identifiers: {
                Email: email,
                PhoneNumber: phone
            }
        });

        _ltk.Alerts.Submit();

        // Show success message within the current form's context
        form.querySelector('.listrak-back-in-stock__success').style.display = 'block';
    }

    /********** End Custom Code ************/
});
